import React from "react";
import { Table } from "react-bootstrap";
import "./Fee_Structure.css";

const feeComponents = [
  { label: "Tuition Fee", amount: "63,250" },
  { label: "Exam Fee", amount: "6,750" },
  { label: "Convocation Fee", amount: "5,000" },
];

const installments = [
  { label: "1st Sem", amount: "₹18,750" },
  { label: "2nd Sem", amount: "₹18,750" },
  { label: "3rd Sem", amount: "₹18,750" },
  { label: "4th Sem", amount: "₹18,750" },
  { label: "5th Sem", amount: "Nil" },
  { label: "6th Sem", amount: "Nil" },
];

const TOTAL_FEE = "75,000";

export default function Fee_Structure() {
  return (
    <section className="fee-structure-section" id="fees">
      <div className="container">
        <div className="fee-section-heading">
          <h2 className="fee-section-title">Fee Structure</h2>

          <p className="fee-section-subtitle">
            Online Bachelor of Commerce (B.Com)
          </p>
        </div>

        <div className="fee-main-card">
          <div className="row g-4">
            <div className="col-12 col-lg-6">
              <div className="fee-card">
                <div className="fee-box-heading">
                  <div className="fee-heading-content">
                    <span className="fee-heading-label">Fee Components</span>
                  </div>
                </div>

                <Table>
                  <thead>
                    <tr>
                      <th>Fee Component</th>
                      <th>Amount</th>
                    </tr>
                  </thead>

                  <tbody>
                    {feeComponents.map((item) => (
                      <tr key={item.label}>
                        <td>{item.label}</td>
                        <td>₹{item.amount}</td>
                      </tr>
                    ))}

                    <tr className="fee-total-row">
                      <td>Total Programme Fee</td>
                      <td>₹{TOTAL_FEE}</td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>

            <div className="col-12 col-lg-6">
              <div className="fee-card">
                <div className="fee-box-heading">
                  <div className="fee-heading-content">
                    <span className="fee-heading-label">Installment Plan</span>
                  </div>
                </div>

                <Table>
                  <thead>
                    <tr>
                      <th>Installment</th>
                      <th>Amount</th>
                    </tr>
                  </thead>

                  <tbody>
                    {installments.map((item) => (
                      <tr key={item.label}>
                        <td>{item.label}</td>
                        <td>{item.amount}</td>
                      </tr>
                    ))}

                    <tr className="fee-total-row">
                      <td>Total</td>
                      <td>₹{TOTAL_FEE}</td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>

            <div className="col-12">
              <div className="fee-scholarship">
                <div className="scholarship-content">
                  <span className="scholarship-label">
                    SPECIAL SCHOLARSHIP OFFER
                  </span>

                  <p className="scholarship-description">
                    A scholarship of{" "}
                    <strong className="scholarship-amount">₹5,000/-</strong>{" "}
                    will be offered to B.Com. students who make payment of the
                    full fee in two transactions within 15 days.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
